# GraphQL fragment to get basic info about a tag

fragment TagBasic on Tag {
    id
    name
    count
    tagType
    color
    createdTime
    creator {
        ... on User {
            id
            name
            isEnabled
        }
        ... on Origin {
            id
            name
        }
    }
    lastUsedTime
}
